import { Button, Flex, Input, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { Card } from "../Card";
import { useMutation, useQueryClient } from "react-query";
import { editInfoFaturamento } from "../requests";

export function InvoicingStep({ payment, partner, refetch }) {
  const [codparc, setCodparc] = useState(null);

  const toast = useToast({
    position: "top-right",
  })

  const queryClient = useQueryClient()

  const { mutateAsync } = useMutation({
    mutationFn: ({ codigo_parceiro, numero_nota }) =>  editInfoFaturamento(codigo_parceiro, numero_nota),
    mutationKey: 'update-faturamento',
    onSuccess: () => {
      queryClient.invalidateQueries('get-values')
      refetch()
      toast({
        title: "Faturamento atualizado com sucesso",
        status: "success",
        duration: 3000,
      })
    },
    onError: (error) => {
      toast({
        title: "Ocorreu um erro ao atualizar o faturamento",
        status: "error",
        duration: 3000,
      })
    },

  })

  async function handleEditInfoFaturamento(codparc, NUNOTA) {
    await mutateAsync({ codigo_parceiro: codparc, numero_nota: NUNOTA })
  }

  return (
    <Flex flexDir="column" height="100%">
      <Card
        title="DADOS DO FATURAMENTO"
        razaoSocial={partner?.fat_razao_social}
        cnpj={partner?.fat_cpf_cnpj}
        ie={partner?.fat_insricao_estadual}
        endereco={partner?.fat_endereco}
        numero={partner?.fat_numero}
        complemento={partner?.fat_complemento}
        bairro={partner?.fat_bairro}
        cidade={partner?.fat_cidade}
        estado={partner?.fat_uf}
        cep={partner?.fat_cep}
        nome={partner?.fat_razao_social}
        email={partner?.fat_email}
        telefone={partner?.fat_telefone}
        celular={partner?.fat_telefone}
        isGreen
      />
      <Flex maxW="300px" mb="1rem" ml="1rem" marginTop="auto">
        <Input placeholder="Parceiro" onChange={(e) => setCodparc(e.target.value)} />
        <Button ml="1rem" onClick={() => handleEditInfoFaturamento(codparc, payment.NUNOTA)}>
          Atualizar
        </Button>
      </Flex>
    </Flex>
  );
}
